import request from '@/utils/request'

/**
 * 获取线下培训列表
 * @param data
 * @returns {AxiosPromise}
 */
export function getTrainListGxj(data) {
  return request({
    url: 'api/getTrainListGxj',
    method: 'post',
    params: data
  })
}

/**
 * 删除线下培训
 * @param data
 * @returns {AxiosPromise}
 */
export function deleteTrainGxj(data) {
  return request({
    url: 'api/deleteTrainGxj',
    method: 'post',
    params: data
  })
}

/**
 * 添加或修改线下培训
 * @param data
 * @returns {AxiosPromise}
 */
export function addOrEditTrainGxj(data) {
  return request({
    url: 'api/addOrEditTrainGxj',
    method: 'post',
    params: data
  })
}

/**
 * 获取线下培训签到场次
 * @param data
 * @returns {AxiosPromise}
 */
export function getTrainCheckById(data) {
  return request({
    url: 'api/getTrainCheckById',
    method: 'post',
    params: data
  })
}

/**
 * 获取线下培训签到预览
 * @param data
 * @returns {AxiosPromise}
 */
export function getTrainRecord(data) {
  return request({
    url: 'api/getTrainRecord',
    method: 'post',
    params: data
  })
}

/**
 * 获取线下培训工作事宜
 * @param data
 * @returns {AxiosPromise}
 */
export function getStaffListById(data) {
  return request({
    url: 'api/getStaffListById',
    method: 'post',
    params: data
  })
}

/**
 * 获取线下指派数据
 * @param data
 * @returns {AxiosPromise}
 */
export function getTrainAssignData(data) {
  return request({
    url: 'api/getTrainAssignData',
    method: 'post',
    params: data
  })
}

/**
 * 获取经销商端线下培训列表
 * @param data
 * @returns {AxiosPromise}
 */
export function getDealerTrainListGxj(data) {
  return request({
    url: 'api/getDealerTrainListGxj',
    method: 'post',
    params: data
  })
}

/**
 * 获取经销商端线下指派数据
 * @param data
 * @returns {AxiosPromise}
 */
export function getDealerTrainAssignData(data) {
  return request({
    url: 'api/getDealerTrainAssignData',
    method: 'post',
    params: data
  })
}

/**
 * 添加或修改经销商端线下培训
 * @param data
 * @returns {AxiosPromise}
 */
export function addOrEditDealerTrainGxj(data) {
  return request({
    url: 'api/addOrEditDealerTrainGxj',
    method: 'post',
    params: data
  })
}

/**
 * 获取线下培训经销商端工作事宜
 * @param data
 * @returns {AxiosPromise}
 */
export function getDealerStaffListById(data) {
  return request({
    url: 'api/getDealerStaffListById',
    method: 'post',
    params: data
  })
}

/**
 * 获取学习任务列表
 * @param data
 * @returns {AxiosPromise}
 */
export function getStudyListGxj(data) {
  return request({
    url: 'api/getStudyListGxj',
    method: 'post',
    params: data
  })
}

/**
 * 删除学习任务列表
 * @param data
 * @returns {AxiosPromise}
 */
export function deleteStudyGxj(data) {
  return request({
    url: 'api/deleteStudyGxj',
    method: 'post',
    params: data
  })
}

/**
 * 添加或修改任务列表
 * @param data
 * @returns {AxiosPromise}
 */
export function addOrEditStudyGxj(data) {
  return request({
    url: 'api/addOrEditStudyGxj',
    method: 'post',
    params: data
  })
}

/**
 * 获取学习任务指派数据
 * @param data
 * @returns {AxiosPromise}
 */
export function getStudyAssignData(data) {
  return request({
    url: 'api/getStudyAssignData',
    method: 'post',
    params: data
  })
}

/**
 * 获取学习任务阶段数据
 * @param data
 * @returns {AxiosPromise}
 */
export function getStudyStageById(data) {
  return request({
    url: 'api/getStudyStageById',
    method: 'post',
    params: data
  })
}

/**
 * 获取经销商端学习指派列表
 * @param data
 * @returns {AxiosPromise}
 */
export function getDealerStudyListGxj(data) {
  return request({
    url: 'api/getDealerStudyListGxj',
    method: 'post',
    params: data
  })
}

/**
 * 添加或修改经销商端学习指派
 * @param data
 * @returns {AxiosPromise}
 */
export function addOrEditDealerStudyGxj(data) {
  return request({
    url: 'api/addOrEditDealerStudyGxj',
    method: 'post',
    params: data
  })
}

/**
 * 获取经销商端线下指派数据
 * @param data
 * @returns {AxiosPromise}
 */
export function getDealerStudyAssignData(data) {
  return request({
    url: 'api/getDealerStudyAssignData',
    method: 'post',
    params: data
  })
}

/**
 * 获取预览线下培训
 * @param data
 * @returns {AxiosPromise}
 */
export function getShowTrainList(data) {
  return request({
    url: 'api/getShowTrainList',
    method: 'post',
    params: data
  })
}

/**
 * 获取预览学习任务
 * @param data
 * @returns {AxiosPromise}
 */
export function getShowStudyList(data) {
  return request({
    url: 'api/getShowStudyList',
    method: 'post',
    params: data
  })
}

/**
 * 获取预览学习进度
 * @param data
 * @returns {AxiosPromise}
 */
export function getStudyRecordList(data) {
  return request({
    url: 'api/getStudyRecordList',
    method: 'post',
    params: data
  })
}
